/* eslint-disable */

import * as Apollo from '@apollo/client';
import { DocumentNode } from 'graphql';
import * as Types from '@99designs/graph-utils/types';

export type ContestProductsQueryVariables = Types.Exact<{
    input: Types.ProductsInput;
}>;

export type ContestProductsQuery = {
    __typename: 'Query';
    products: Array<
        | { __typename: 'ProductFixedPriceProject' }
        | {
              __typename: 'ProductContest';
              key: string;
              name: string;
              title: string;
              description: string;
              details: Array<string>;
              pricing: {
                  __typename: 'FixedPrice';
                  earningsInUsd: number;
                  amounts: Array<{ __typename: 'Money'; amountInCents: number; currency: string }>;
                  amount: { __typename: 'Money'; amountInCents: number; currency: string };
              };
          }
        | { __typename: 'ProductQuotedProject' }
    >;
};

export const ContestProductsDocument: DocumentNode = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'ContestProducts' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'ProductsInput' } },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'products' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'input' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                        kind: 'NamedType',
                                        name: { kind: 'Name', value: 'ProductContest' },
                                    },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'name' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'title' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'description' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'details' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'pricing' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'amounts',
                                                            },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    {
                                                                        kind: 'Field',
                                                                        name: {
                                                                            kind: 'Name',
                                                                            value: 'amountInCents',
                                                                        },
                                                                    },
                                                                    {
                                                                        kind: 'Field',
                                                                        name: {
                                                                            kind: 'Name',
                                                                            value: 'currency',
                                                                        },
                                                                    },
                                                                ],
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'amount' },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    {
                                                                        kind: 'Field',
                                                                        name: {
                                                                            kind: 'Name',
                                                                            value: 'amountInCents',
                                                                        },
                                                                    },
                                                                    {
                                                                        kind: 'Field',
                                                                        name: {
                                                                            kind: 'Name',
                                                                            value: 'currency',
                                                                        },
                                                                    },
                                                                ],
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'earningsInUsd',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};

/**
 * __useContestProductsQuery__
 *
 * To run a query within a React component, call `useContestProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useContestProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContestProductsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useContestProductsQuery(
    baseOptions: Apollo.QueryHookOptions<ContestProductsQuery, ContestProductsQueryVariables>
) {
    return Apollo.useQuery<ContestProductsQuery, ContestProductsQueryVariables>(
        ContestProductsDocument,
        baseOptions
    );
}
export function useContestProductsLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<ContestProductsQuery, ContestProductsQueryVariables>
) {
    return Apollo.useLazyQuery<ContestProductsQuery, ContestProductsQueryVariables>(
        ContestProductsDocument,
        baseOptions
    );
}
export type ContestProductsQueryHookResult = ReturnType<typeof useContestProductsQuery>;
export type ContestProductsLazyQueryHookResult = ReturnType<typeof useContestProductsLazyQuery>;
export type ContestProductsQueryResult = Apollo.QueryResult<
    ContestProductsQuery,
    ContestProductsQueryVariables
>;
